import React from 'react';
import { List } from 'antd';
import { get, isEmpty } from 'lodash';
import { Retry } from '@components/common';
import { SectionWrapper, StyledMoreDrawer } from '../styled';
import { StyledList, StyledDateContainer } from './styled';
import Row from './Row';
import { useFetchSummary, useOpenSummary } from './hooks';
import { SkeletonLoader, More } from '../Common';
import { getEndTime } from './utils';
import ReleaseTagDate from './ReleaseTagDate';

// TODO: Move to constants
const PREVIEW_LIMIT = 2;
export const MAX_LIMIT = 100;

const voidFn = () => null;

function Insights({ openMore = voidFn, closeMore = voidFn, showMore = true }) {
  const to = getEndTime('hour');
  const limit = showMore ? PREVIEW_LIMIT : MAX_LIMIT;

  const { isLoading, isFetching, isError, data, refetch } = useFetchSummary({ to });

  const { versionData = [] } = get(data, 'data.response.newVersionData', {});
  const count = versionData.length;
  const slicedversionData = versionData.slice(0, limit);

  const openSummary = useOpenSummary({ closeMore });

  return (
    <SectionWrapper>
      <Retry
        isLoading={isLoading || isFetching}
        showError={isError}
        isEmpty={isEmpty(versionData)}
        mountChildAlways={false}
        fetchData={refetch}
        LoadingLayer={SkeletonLoader}
      >
        <StyledList
          itemLayout="horizontal"
          split={false}
          footer={
            showMore ? <More count={count - slicedversionData.length} onClick={openMore} /> : null
          }
        >
          {slicedversionData.map((row: any, i: React.Key | null | undefined) => (
            <List.Item key={i}>
              <StyledDateContainer key={i}>
                <ReleaseTagDate currentKey={i} data={row} versionData={versionData} />
                <Row data={row} openSummary={openSummary} />
              </StyledDateContainer>
            </List.Item>
          ))}
        </StyledList>
      </Retry>
    </SectionWrapper>
  );
}

function MoreDrawer({ closeMore, visible }) {
  return (
    <StyledMoreDrawer
      title="New App Version"
      placement="right"
      closable
      onClose={closeMore}
      open={visible}
      key="alert-insights-drawer"
      mask
      width={400}
      // destroyOnHidden={true}
    >
      <Insights showMore={false} closeMore={closeMore} />
    </StyledMoreDrawer>
  );
}

export { Insights, MoreDrawer };
